module.exports = __webpack_public_path__ + "img/1267043823.80ec463e.jpg";